import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const DataContext = createContext();

export function DataProvider({ children }) {
  const [cars, setCars] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [rentals, setRentals] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [reports, setReports] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    if (!token) {
      console.warn('⚠️ Токен не найден — данные не загружены');
      return;
    }

    const headers = { headers: { Authorization: `Bearer ${token}` } };

    (async () => {
      try {
        const [carsRes, custRes, rentRes, expRes] = await Promise.all([
          axios.get(`${API_URL}/api/cars`, headers),
          axios.get(`${API_URL}/api/customers`, headers),
          axios.get(`${API_URL}/api/rentals`, headers),
          axios.get(`${API_URL}/api/expenses`, headers),
        ]);

        setCars(carsRes.data);
        setCustomers(custRes.data);
        setRentals(rentRes.data);
        setExpenses(expRes.data);
      } catch (err) {
        console.error('Ошибка загрузки данных:', err.response?.data || err.message);
      }
    })();
  }, []);

  return (
    <DataContext.Provider
      value={{
        cars, setCars,
        customers, setCustomers,
        rentals, setRentals,
        expenses, setExpenses,
        reports, setReports,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
